import Route from '@ember/routing/route';

export default class StaffRoute extends Route {}
